// extracted by mini-css-extract-plugin
export default {"galleryTitle":"Car_galleryTitle__OBkXS","loading":"Car_loading__tgL5-"};